import { AuthLayout } from '../components/auth-layout/auth-layout';
import { BaseMessageView } from '../components/base-message-view';

type Props = {
  onRetry: () => void;
  onSignIn: () => void;
  processing: boolean;
};

export const SessionRecovery = ({ onRetry, onSignIn, processing }: Props) => (
  <AuthLayout animation={false}>
    <BaseMessageView
      title="We couldn't verify your session"
      message="Check your connection and try again."
      action="Retry"
      processing={processing}
      onAction={onRetry}
      onSignIn={onSignIn}
    />
  </AuthLayout>
);
